import { Input } from '@/components/common/Input';
import { Select } from '@/components/common/Select';
import type { CameraMetadata } from '@/types/waypoint';

interface CameraFormProps {
  metadata: Partial<CameraMetadata>;
  onChange: (updated: Partial<CameraMetadata>) => void;
}

const CAMERA_TYPE_OPTIONS = [
  { value: 'sd_card', label: 'SD Card' },
  { value: 'cellular', label: 'Cellular' },
];

export function CameraForm({ metadata, onChange }: CameraFormProps) {
  return (
    <div className="flex flex-col gap-4">
      <Input
        id="camera-model"
        label="Camera Model"
        value={metadata.cameraModel ?? ''}
        onChange={(v) => onChange({ ...metadata, cameraModel: v || undefined })}
        placeholder="e.g. Stealth Cam G42"
      />

      <Select
        id="camera-type"
        label="Camera Type"
        value={metadata.cameraType ?? 'sd_card'}
        onChange={(v) =>
          onChange({ ...metadata, cameraType: v as CameraMetadata['cameraType'] })
        }
        options={CAMERA_TYPE_OPTIONS}
      />

      <Input
        id="camera-facing"
        label="Facing Direction"
        value={metadata.facing ?? ''}
        onChange={(v) => onChange({ ...metadata, facing: v || undefined })}
        placeholder="e.g. N, SW"
      />
    </div>
  );
}
